import React from 'react';
import PropTypes from 'prop-types';
import UserImage from '../../../Content/User/UserDisplay/UserImage/UserImage';

import './CommentUserImage.scss';

const CommentUserImage = ({ isVip, authorImage }) => {
    return (
        <div className="component-CommentUserImage">
            <UserImage isVip={isVip} image={authorImage} />
        </div>
    );
};

CommentUserImage.propTypes = {
    isVip: PropTypes.bool,
    authorImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
};

CommentUserImage.defaultProps = {
    isVip: false,
    authorImage: {},
};

CommentUserImage.displayName = 'CommentBoxInput';

export default CommentUserImage;
